import React, { useState, type SelectHTMLAttributes } from 'react';
import type { FieldValues, Path, RegisterOptions, UseFormRegister } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Status = 'active' | 'pending' | 'inactive' | 'archived' | 'invited' | 'design' | 'draft' | 'all';

interface StatusInputProps<T extends FieldValues> extends SelectHTMLAttributes<HTMLSelectElement> {
  register: UseFormRegister<T>;
  registerName: Path<T>;
  registerProps?: RegisterOptions<T, Path<T>>;
  label?: string;
  shownStatuses?: Status[];
}

export const StatusInput = <T extends FieldValues>({ register, registerName, registerProps, label, shownStatuses, ...rest }: StatusInputProps<T>) => {
  const { t } = useTranslation();
  const [selectedStatus, setSelectedStatus] = useState<Status>('active');

  const handleStatusChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const status = event.target.value as Status;
    setSelectedStatus(status);
  };

  const getShownOptions = () => {
    if (!shownStatuses) {
      return ['active', 'pending', 'inactive', 'archived', 'design', 'draft', 'invited'];
    }

    return shownStatuses;
  };

  const getOptions = () => {
    const options = getShownOptions();

    return (
      <>
        <option value={''}>{t('common.noSelected')}</option>
        {options.map((status) => (
          <option key={status} value={status}>
            {t(`table.status.${status}`)}
          </option>
        ))}
      </>
    );
  };

  return (
    <div>
      {label && <label className="block text-sm font-medium text-gray-700">{label}</label>}
      <select
        {...rest}
        {...register(registerName, registerProps)}
        value={selectedStatus}
        defaultValue={rest.defaultValue}
        onChange={handleStatusChange}
        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:border-transparent">
        {/* <option value={""}>{t("common.noSelected")}</option>
				<option value="active"> {t("table.status.active")} </option>
				<option value="invited">{t("table.status.invited")}</option>
				<option value="inactive">{t("table.status.inactive")}</option>
				<option value="archived">{t("table.status.archived")}</option>
				<option value="design">{t("table.status.design")}</option>
				<option value="draft">{t("table.status.draft")}</option> */}
        {getOptions()}
      </select>
    </div>
  );
};
